import type { SharedData } from '../../types';

import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { openInstagramShare } from './shareCommand';
import { routeForSource } from './shareSourceRoutes';

export function useReopenShare(pharmacyId: string) {
  const navigate = useNavigate();

  return useCallback(
    (data: SharedData) => {
      if (data.source) {
        const route = routeForSource(data.source, pharmacyId);

        if (route) {
          navigate(route);
        }
      }

      openInstagramShare(data);
    },
    [navigate, pharmacyId]
  );
}
